'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

/**
 * Get Styled Component shimmer loader theme
 * @param options GetShimmerLoaderThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getShimmerLoaderTheme = (options)=>{
    const { look  } = options;
    return styled.css`
    background: linear-gradient(
      to right,
      ${({ theme  })=>theme.shimmerLoader[look].gradientLight} 4%,
      ${({ theme  })=>theme.shimmerLoader[look].gradientDark} 25%,
      ${({ theme  })=>theme.shimmerLoader[look].gradientLight} 36%
    );
  `;
};

exports.getShimmerLoaderTheme = getShimmerLoaderTheme;
//# sourceMappingURL=shimmer-loader.js.map
